import { observer } from 'mobx-react-lite'
import { ContainerHeader, Typography } from 'shared/ui'
import {
  CreateTagsButton,
  GuideTagsButton,
} from 'pages/settings/pages/tags/ui/TagsAction/TagsAction'
import styles from './styles.module.scss'

export const TagsListHeader = observer(() => {
  return (
    <ContainerHeader
      customTitle={
        <header className={styles.header}>
          <Typography variant='heading-lg' ariaLabel='Tags header'>
            Tags
          </Typography>
          <Typography
            className={styles.headerDescription}
            variant='body-md-regular'
            ariaLabel='Tags description'
          >
            View, edit, and manage all your contact tags
          </Typography>
        </header>
      }
      paddingTop={90}
      paddingBottom={50}
      paddingLeft={4}
      paddingRight={4}
      actionsProps={{
        gap: 8,
        actions: [
          { iconButtonComponent: <GuideTagsButton className={styles.guideButton} /> },
          { iconButtonComponent: <CreateTagsButton /> },
        ],
      }}
    />
  )
})
